const psProperties = {
    firstSeenAt: 'ps_first_seen_at',
    startSlug: 'ps_start_slug',
    startPage: 'ps_start_page',
    endSlug: 'ps_end_slug',
    convertedAt: 'ps_converted_at',
    completedAt: 'ps_completed_at',
    closedAt: 'ps_closed_at',
    lastSeenAt: 'ps_last_seen_at',
    isConverted: 'ps_converted',
    isCompleted: 'ps_completed',
    isClosed: 'ps_closed',
    result: 'ps_result_page',
    calendlyBook: 'ps_calendly_booked',
    calBook: 'ps_cal_booked',
    ghlBook: 'ps_ghl_booked',
    hubspotBook: 'ps_hubspot_booked',
    iclosedBook: 'ps_iclosed_booked',
    cookies: 'ps_cookies',
    isEmbed: 'ps_embed',
    timezone: 'ps_timezone',
} as const;

/**
 * The traits that turn a visitor into a lead.
 *
 * `TrackingSession` derives `ps_converted` from them, and server-side crm-api only creates a
 * contact once that flag is set. Kept here rather than in the session so that a leaf module
 * owns the definition.
 */
export const CONTACT_TRAIT_KEYS = ['email', 'phone'] as const;

export default psProperties;
